<template>
  <AdminBackground>
    <div class="image-wrapper">
      <img
        src="@/assets/header/PERPARITAN.png"
        alt="PERPARITAN"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>


    <div class="content-wrapper"> 
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            label="Negeri"
            :items="negeri"
            placeholder="Semua Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Semua PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
          />
        </div>
      </div>   
      <h2>PERPARITAN</h2>

      <div class="vektor">
        <!-- First Image -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>PANJANG PARIT/LONGKANG (meter)</h3>
              <p class="number">
                585
              </p>
            </div>
          </div>
        </div>

        <!-- Second Image -->
        <div class="vektor-container">
          <img
            src="@/assets/spah/box.png"
            alt="Second Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>PANJANG CULVERT (meter)</h3>
              <p class="number">
                336
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>


    <PrimaryModule />
    <KejuruteraanKesihatanMenu />  
  </AdminBackground>
</template>

<script setup>
definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})
</script>

<style scoped>
.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; 
  margin-block-start: 10px;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}



.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}


.input-item {
  flex: 1;
  margin-right: 15px;
}


.input-item:last-child {
  margin-right: 0;
}



h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: left;
}


.vektor {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 10px; /* Adjust gap to add space between the boxes */
}

.vektor-container {
  width: 48%; /* Ensures both columns fit side by side */
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}


.activity-box {
  position: relative;
  display: inline-block;
  width: 100%;
  height: auto;
  border-radius: 10px;
  overflow: hidden;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.box-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
}

.box-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #150069;
}

.box-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #a80000;
}

.activity-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* This ensures 4 equal-width boxes */
  gap: 30px; /* Adjust the spacing between the boxes */
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.2rem;
    text-align: center;
  }

  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  .vektor {
    flex-direction: column;
    gap: 15px;
  }

  .vektor-container {
    width: 100%;
  }

  .values-layered h3 {
    font-size: 16px;
  }

  .number {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  h2 {
    font-size: 1rem;
    text-align: center;
  }

  .vektor {
    flex-direction: column;
    gap: 10px;
  }

  .values-layered h3 {
    font-size: 14px;
  }

  .number {
    font-size: 18px;
  }
}
</style>
